import { ChangeDetectionStrategy, Component, Signal, ViewEncapsulation, computed, inject } from '@angular/core';
import { ProfileService } from '../../process';

@Component({
  selector: 'club-label',
  standalone: true,
  template: `
    @if(clubLabel$$()) {
    <span>{{ clubLabel$$() }}</span>
    }
  `,
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ClubLabelComponent {
  private _profileService = inject(ProfileService);

  get clubLabel$$(): Signal<string> {
    return computed(() => this._profileService.clubLabel$$());
  }
}
